var map = {
	"./_0-COVER-paramo.jpeg": 7991,
	"./_1-paramo.png": 5453,
	"./_10-paramo-empaques.png": 5886,
	"./_11-COVER-paramo.png": 4571,
	"./_2-paramo-colores.png": 4624,
	"./_3-paramo-formas.png": 7217,
	"./_4-paramo-formas.png": 6281,
	"./_5-paramo-alfabeto-grafico.png": 5320,
	"./_6-paramo-patron.png": 4174,
	"./_7-paramo-patron2.png": 7549,
	"./_8-paramo-productos.png": 7465,
	"./_9-paramo-vitrinas.png": 4475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;